export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-2.5" data-testid="brand-logo">
      <img
        src="/logo-badge.png"
        alt="Tricity Kroonerz logo — fist holding a vintage microphone"
        className="h-10 w-10 shrink-0 rounded-full border border-gold/40 object-cover"
      />
      {!compact && (
        <span className="leading-none">
          <span className="block font-serif text-lg font-bold tracking-wide text-ivory">
            Tricity <span className="text-gold">Kroonerz</span>
          </span>
          <span className="mt-1 block text-[9px] font-semibold uppercase tracking-[0.32em] text-slate-400">
            Where Passion Meets the Classics
          </span>
        </span>
      )}
    </span>
  );
}
